import { getLocalApi } from 'app/shared/api/localApi';
import apiConfig from 'app/api/apiConfig.json';
import type { TaxRuleApiDto } from './types';

export async function getTaxRuleById(id: number): Promise<TaxRuleApiDto | null> {
  const localApi = await getLocalApi();
  const template = (apiConfig as Record<string, string>).tax_rules_get_by_id;
  if (!template) {
    throw new Error('Tax rule by id API is not configured');
  }
  const url = template.replace('{id}', String(id));
  const res = await localApi.call(url, 'GET', null);
  if (!res?.ok) return null;
  if (res.status === 204) return null;
  const text = await res.text().catch(() => '');
  if (!text) return null;
  try {
    return JSON.parse(text) as TaxRuleApiDto;
  } catch {
    return null;
  }
}